export default __webpack_public_path__ + "static/media/hours.inline.10e6ea27.svg";